import * as React from 'react';
import styles from './index.less';
import { connect } from 'dva';
import { ConnectState, NodeManagerModelState } from '@/models/connect';
import { Helmet } from 'react-helmet';
import { Dispatch } from 'redux';
import Sider from '../Sider';
import FComponentsLib from '@freelog/components-lib';
import { Radio, Space } from 'antd';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import * as AHooks from 'ahooks';
import {
  OnChange_Setting_Cover_Action,
  OnChange_Setting_Introduction_Action,
  OnChange_Setting_Limitation_Action,
  OnChange_Setting_NodeLimitationMessage_Action,
  OnChange_Setting_Title_Action,
  OnClick_Setting_CancelEditBtn_Action,
  OnClick_Setting_EditBtn_Action,
  OnClick_Setting_SaveEditBtn_Action,
  OnMount_SettingPage_Action,
  OnUnmount_SettingPage_Action,
} from '@/models/nodeManagerPage';
import fMessage from '@/components/fMessage';
import FUploadNodeCover from '@/components/FUploadNodeCover';
import * as imgSrc from '@/assets/default-node-cover.png';
import FNodeCoverImage from '@/components/FNodeCoverImage';
// import FInput_MultiLine from '@/components/FInput_MultiLine';
import FLeftSiderLayout from '@/layouts/FLeftSiderLayout';
import { history } from 'umi';
import { FetchNodesAction } from '@/models/nodes';
import FModal from '@/components/FModal';
// import FSingleLineInput from '@/components/FSingleLineInput';
import FIcons from '@/components/FIcons';
import FCopyToClipboard from '@/components/FCopyToClipboard';
import FInput_PinyinSafeTextCounter from '@/components/FInput_PinyinSafeTextCounter';
import FInput_PinyinSafeTextCounter_MultiLine from '@/components/FInput_PinyinSafeTextCounter_MultiLine';
// import FLoadingTip from '@/components/FLoadingTip';

interface SettingProps {
  dispatch: Dispatch;
  nodeManagerPage: NodeManagerModelState;
}

function Setting({ dispatch, nodeManagerPage }: SettingProps) {
  const ref = React.useRef<any>();
  const [$introductionShowAll, set$introductionShowAll, get$introductionShowAll] =
    FUtil.Hook.useGetState<'all' | 'part' | 'ignore'>('ignore');

  const [$deleteNodeModalOpen, set$deleteNodeModalOpen, get$deleteNodeModalOpen] =
    FUtil.Hook.useGetState<boolean>(false);
  const [$deleteNodeName, set$deleteNodeName, get$deleteNodeName] =
    FUtil.Hook.useGetState<string>('');

  AHooks.useMount(() => {
    dispatch<OnMount_SettingPage_Action>({
      type: 'nodeManagerPage/onMount_SettingPage',
    });
  });

  AHooks.useUnmount(() => {
    dispatch<OnUnmount_SettingPage_Action>({
      type: 'nodeManagerPage/onUnmount_SettingPage',
    });
  });

  AHooks.useDebounceEffect(
    () => {
      console.log(ref.current?.clientHeight, 'ref.current?.clientHeight sdi8ofjlksdjlkjlk');
      console.log(ref.current?.scrollHeight, 'ref.current?.clientHeight sdi8ofjlksdjlkjlk');
      // if ((ref.current?.clientHeight || 0) < (ref.current?.scrollHeight || 0)) {
      if ((ref.current?.scrollHeight || 0) > 200) {
        set$introductionShowAll('part');
      } else {
        set$introductionShowAll('ignore');
      }
    },
    [nodeManagerPage.setting_nodeInfo.introduction],
    {
      wait: 100,
    },
  );

  return (
    <>
      <Helmet>
        <title>{`节点设置 · ${nodeManagerPage.nodeName} - Freelog`}</title>
      </Helmet>

      {/*<FSiderContentLayout*/}
      <FLeftSiderLayout
        // header={''}
        sider={<Sider />}
        type='empty'
      >
        <div className={styles.content}>
          <div className={styles.header}>
            <FComponentsLib.FTitleText
              type={'h1'}
              text={FI18n.i18nNext.t('nodemgnt_nodesetting_page_title')}
            />
            <Space size={30}>
              <Space size={5}>
                <FComponentsLib.FContentText
                  text={FI18n.i18nNext.t('nodemgnt_nodesetting_nodeaddress')}
                  type={'additional2'}
                />
                <FComponentsLib.FContentText
                  text={nodeManagerPage.setting_nodeUrl}
                  type={'additional2'}
                />
                <FCopyToClipboard
                  text={nodeManagerPage.setting_nodeUrl}
                  iconStyle={{ fontSize: 14 }}
                  title={FI18n.i18nNext.t('tip_copy_node_domain')}
                />
              </Space>
              <Space size={5}>
                <FComponentsLib.FContentText
                  text={FI18n.i18nNext.t('nodemgnt_nodesetting_nodeid')}
                  type={'additional2'}
                />
                <FComponentsLib.FContentText
                  text={String(nodeManagerPage.setting_nodeName)}
                  type={'additional2'}
                />
                <FCopyToClipboard
                  text={String(nodeManagerPage.setting_nodeName)}
                  iconStyle={{ fontSize: 14 }}
                  title={'复制'}
                />
              </Space>
            </Space>
          </div>
          <div className={styles.panel}>
            <FComponentsLib.FTitleText
              type={'h3'}
              text={FI18n.i18nNext.t('nodemgnt_nodesetting_nodelogo')}
            />
            <div style={{ height: 20 }} />

            {nodeManagerPage.setting_state === 'normal' ? (
              nodeManagerPage.setting_pageState === 'loading' ? (
                <div style={{ height: 80 }} />
              ) : (
                <div className={styles.nodeCover} style={{ cursor: 'default' }}>
                  {/*<img*/}
                  {/*  style={{ height: 72, width: 72, borderRadius: '50%' }}*/}
                  {/*  src={nodeManagerPage.setting_nodeInfo.cover || imgSrc}*/}
                  {/*  alt=''*/}
                  {/*/>*/}
                  {nodeManagerPage.setting_pageState === 'loaded' && (
                    <FNodeCoverImage
                      src={nodeManagerPage.setting_nodeInfo.cover || imgSrc}
                      // width={72}
                    />
                  )}
                </div>
              )
            ) : (
              <FUploadNodeCover
                onUploadSuccess={(url) => {
                  // console.log(url, 'sdoifjsdlkfj **(******');
                  dispatch<OnChange_Setting_Cover_Action>({
                    type: 'nodeManagerPage/onChange_Setting_Cover',
                    payload: {
                      value: url,
                    },
                  });
                }}
                onError={(err) => {
                  fMessage(err, 'error');
                }}
              >
                <div className={styles.nodeCover}>
                  <FNodeCoverImage src={nodeManagerPage.setting_nodeCover || imgSrc} />
                  <div className={styles.nodeCoverMask}>
                    <span>更换</span>
                  </div>
                </div>
              </FUploadNodeCover>
            )}

            <div style={{ height: 40 }} />

            <FComponentsLib.FTitleText
              type={'h3'}
              text={FI18n.i18nNext.t('nodemgnt_nodesetting_nodetitle')}
            />

            <div style={{ height: 20 }} />
            {nodeManagerPage.setting_state === 'normal' ? (
              <div className={styles.nodeName}>
                {nodeManagerPage.setting_nodeInfo.title ? (
                  <FComponentsLib.FContentText
                    text={nodeManagerPage.setting_nodeInfo.title}
                    type={'normal'}
                  />
                ) : (
                  <i style={{ color: '#999' }}>暂无无内容...</i>
                )}
              </div>
            ) : (
              <div className={styles.nodeName1}>
                {/* <FComponentsLib.FInput.FSingleLine */}
                <FInput_PinyinSafeTextCounter
                  value={nodeManagerPage.setting_nodeTitle}
                  onChangeValue={(v) => {
                    dispatch<OnChange_Setting_Title_Action>({
                      type: 'nodeManagerPage/onChange_Setting_Title',
                      payload: {
                        value: v,
                      },
                    });
                  }}
                  lengthLimit={100}
                  size='middle'
                  style={{ width: 380 }}
                  // placeholder={FI18n.i18nNext.t('form_input_singlelinetxt_error_length')}
                />
                {nodeManagerPage.setting_nodeTitle_Error !== '' && (
                  <>
                    <div style={{ height: 5 }} />
                    <FComponentsLib.FContentText
                      type={'additional2'}
                      text={nodeManagerPage.setting_nodeTitle_Error}
                      style={{ color: '#EE4040' }}
                    />
                  </>
                )}
              </div>
            )}

            <div style={{ height: 40 }} />

            <FComponentsLib.FTitleText
              type={'h3'}
              text={FI18n.i18nNext.t('nodemgnt_nodesetting_nodeshortdesc')}
            />
            <div style={{ height: 20 }} />
            {nodeManagerPage.setting_state === 'normal' && (
              <>
                <div className={styles.introduction}>
                  {nodeManagerPage.setting_nodeInfo.introduction !== '' && (
                    <>
                      <div
                        ref={ref}
                        className={styles.aboutPanel}
                        style={{
                          ...($introductionShowAll === 'part' ? { maxHeight: 200 } : {}),
                        }}
                      >
                        <pre>{nodeManagerPage.setting_nodeInfo.introduction}</pre>
                      </div>
                    </>
                  )}
                  {nodeManagerPage.setting_nodeInfo.introduction === '' && (
                    <i
                      style={{
                        color: '#999',
                        paddingLeft: 10,
                      }}
                    >
                      {FI18n.i18nNext.t('nodemgnt_nodesetting_nodeshortdesc_empty')}
                    </i>
                  )}
                </div>

                {$introductionShowAll !== 'ignore' && (
                  <>
                    <div style={{ height: 5 }} />
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                      {$introductionShowAll === 'all' && (
                        <FComponentsLib.FTextBtn
                          style={{ fontSize: 12 }}
                          onClick={() => {
                            set$introductionShowAll('part');
                          }}
                        >
                          收起
                        </FComponentsLib.FTextBtn>
                      )}
                      {$introductionShowAll === 'part' && (
                        <FComponentsLib.FTextBtn
                          style={{ fontSize: 12 }}
                          onClick={() => {
                            set$introductionShowAll('all');
                          }}
                        >
                          全部展开
                        </FComponentsLib.FTextBtn>
                      )}
                    </div>
                  </>
                )}
              </>
            )}
            {nodeManagerPage.setting_state !== 'normal' && (
              <div className={styles.introduction1}>
                {/*<FComponentsLib.FInput.FMultiLine*/}
                <FInput_PinyinSafeTextCounter_MultiLine
                  value={nodeManagerPage.setting_nodeIntroduction}
                  onChangeValue={(v) => {
                    dispatch<OnChange_Setting_Introduction_Action>({
                      type: 'nodeManagerPage/onChange_Setting_Introduction',
                      payload: {
                        value: v,
                      },
                    });
                  }}
                  lengthLimit={1000}
                />
              </div>
            )}
            <div style={{ height: 40 }} />

            <FComponentsLib.FTitleText
              type={'h3'}
              text={FI18n.i18nNext.t('nodemgnt_nodesetting_visibility')}
            />
            <div style={{ height: 20 }} />
            <div className={styles.permission}>
              <div>
                {nodeManagerPage.setting_state === 'normal' ? (
                  <Radio
                    checked={nodeManagerPage.setting_nodeInfo.limitation === 'public'}
                    disabled={true}
                    style={{ margin: 0 }}
                  />
                ) : (
                  <Radio
                    checked={nodeManagerPage.setting_nodeLimitation === 'public'}
                    onChange={(e) => {
                      if (e.target.checked) {
                        dispatch<OnChange_Setting_Limitation_Action>({
                          type: 'nodeManagerPage/onChange_Setting_Limitation',
                          payload: {
                            value: 'public',
                          },
                        });
                      }
                    }}
                    disabled={false}
                    style={{ margin: 0 }}
                  />
                )}
              </div>
              <div>
                <FComponentsLib.FContentText
                  text={FI18n.i18nNext.t('nodemgnt_nodesetting_visibility_public')}
                  type={'normal'}
                />
              </div>
              <div>
                <FComponentsLib.FContentText
                  text={FI18n.i18nNext.t('nodemgnt_nodesetting_visibility_public_info')}
                  type={'additional2'}
                  style={{ lineHeight: '20px' }}
                />
              </div>

              <div>
                {nodeManagerPage.setting_state === 'normal' ? (
                  <Radio
                    checked={nodeManagerPage.setting_nodeInfo.limitation === 'private'}
                    disabled={true}
                    style={{ margin: 0 }}
                  />
                ) : (
                  <Radio
                    checked={nodeManagerPage.setting_nodeLimitation === 'private'}
                    onChange={(e) => {
                      if (e.target.checked) {
                        dispatch<OnChange_Setting_Limitation_Action>({
                          type: 'nodeManagerPage/onChange_Setting_Limitation',
                          payload: {
                            value: 'private',
                          },
                        });
                      }
                    }}
                    disabled={false}
                    style={{ margin: 0 }}
                  />
                )}
              </div>
              <div>
                <FComponentsLib.FContentText
                  text={FI18n.i18nNext.t('nodemgnt_nodesetting_visibility_private')}
                  type={'normal'}
                />
              </div>
              <div>
                <FComponentsLib.FContentText
                  text={FI18n.i18nNext.t('nodemgnt_nodesetting_visibility_private_info')}
                  type={'additional2'}
                  style={{ lineHeight: '20px' }}
                />
              </div>

              <div>
                {nodeManagerPage.setting_state === 'normal' ? (
                  <Radio
                    checked={nodeManagerPage.setting_nodeInfo.limitation === 'pause'}
                    disabled={true}
                    style={{ margin: 0 }}
                  />
                ) : (
                  <Radio
                    checked={nodeManagerPage.setting_nodeLimitation === 'pause'}
                    onChange={(e) => {
                      if (e.target.checked) {
                        dispatch<OnChange_Setting_Limitation_Action>({
                          type: 'nodeManagerPage/onChange_Setting_Limitation',
                          payload: {
                            value: 'pause',
                          },
                        });
                      }
                    }}
                    disabled={false}
                    style={{ margin: 0 }}
                  />
                )}
              </div>
              <div>
                <FComponentsLib.FContentText
                  text={FI18n.i18nNext.t('nodemgnt_nodesetting_visibility_hidefromvisitor')}
                  type={'normal'}
                />
              </div>
              <div>
                <FComponentsLib.FContentText
                  text={FI18n.i18nNext.t('nodemgnt_nodesetting_visibility_hidefromvisitor_info')}
                  type={'additional2'}
                  style={{ lineHeight: '20px' }}
                />
                {nodeManagerPage.setting_state === 'editing' &&
                  nodeManagerPage.setting_nodeLimitation === 'pause' && (
                    <>
                      <div style={{ height: 15 }} />
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                        }}
                      >
                        <FComponentsLib.FContentText
                          text={FI18n.i18nNext.t('nodemgnt_nodesetting_changenotice_title')}
                          type={'additional2'}
                        />
                        <FComponentsLib.FTextBtn
                          type={'primary'}
                          style={{ fontSize: 12 }}
                          onClick={() => {
                            self.open(
                              '/nodePausePreview?tip=' +
                                encodeURIComponent(
                                  nodeManagerPage.setting_nodeLimitationMessage ||
                                    FI18n.i18nNext.t('nodemgnt_nodesetting_changenotice_default'),
                                ),
                            );
                          }}
                        >
                          {/* 预览 */}
                          {FI18n.i18nNext.t('nodemgnt_nodesetting_changenotice_btn_preview')}
                        </FComponentsLib.FTextBtn>
                      </div>
                      <div style={{ height: 15 }} />
                      {/* <FComponentsLib.FInput.FSingleLine */}
                      <FInput_PinyinSafeTextCounter
                        value={nodeManagerPage.setting_nodeLimitationMessage}
                        onChangeValue={(v) => {
                          dispatch<OnChange_Setting_NodeLimitationMessage_Action>({
                            type: 'nodeManagerPage/onChange_Setting_NodeLimitationMessage',
                            payload: {
                              value: v,
                            },
                          });
                        }}
                        lengthLimit={100}
                        style={{ width: 740 }}
                        placeholder={FI18n.i18nNext.t('nodemgnt_nodesetting_changenotice_default')}
                      />
                    </>
                  )}
              </div>
            </div>
            <div style={{ height: 40 }} />

            <div className={styles.editBtn}>
              {nodeManagerPage.setting_state === 'normal' && (
                <FComponentsLib.FRectBtn
                  type={'primary'}
                  onClick={() => {
                    dispatch<OnClick_Setting_EditBtn_Action>({
                      type: 'nodeManagerPage/onClick_Setting_EditBtn',
                    });
                  }}
                >
                  {FI18n.i18nNext.t('nodemgnt_nodesetting_btn_edit')}
                </FComponentsLib.FRectBtn>
              )}

              {nodeManagerPage.setting_state === 'editing' && (
                <>
                  <FComponentsLib.FTextBtn
                    type={'default'}
                    onClick={() => {
                      dispatch<OnClick_Setting_CancelEditBtn_Action>({
                        type: 'nodeManagerPage/onClick_Setting_CancelEditBtn',
                      });
                    }}
                  >
                    {/* 取消 */}
                    {FI18n.i18nNext.t('btn_cancel')}
                  </FComponentsLib.FTextBtn>
                  <FComponentsLib.FRectBtn
                    type={'primary'}
                    onClick={() => {
                      dispatch<OnClick_Setting_SaveEditBtn_Action>({
                        type: 'nodeManagerPage/onClick_Setting_SaveEditBtn',
                      });
                    }}
                    disabled={
                      nodeManagerPage.setting_nodeTitle === '' ||
                      nodeManagerPage.setting_nodeTitle_Error !== '' ||
                      nodeManagerPage.setting_nodeIntroduction.length > 1000 ||
                      (nodeManagerPage.setting_nodeLimitation === 'pause' &&
                        nodeManagerPage.setting_nodeLimitationMessage.length > 100)
                    }
                  >
                    {/* 确定 */}
                    {FI18n.i18nNext.t('btn_save')}
                  </FComponentsLib.FRectBtn>
                </>
              )}
            </div>
          </div>
          {nodeManagerPage.setting_nodeInfo.limitation === 'pause' && (
            <div
              style={{
                width: 920,
                display: 'flex',
                justifyContent: 'flex-end',
                paddingTop: 15,
              }}
            >
              <FComponentsLib.FTextBtn
                type={'danger'}
                style={{ display: 'flex', alignItems: 'center', gap: 2 }}
                onClick={() => {
                  set$deleteNodeModalOpen(true);
                }}
              >
                <FIcons.FDelete style={{ color: 'inherit', fontSize: 14 }} />
                {/*<span>删除节点</span>*/}
                <span>{FI18n.i18nNext.t('nodemgnt_nodesetting_btn_deletenode')}</span>
              </FComponentsLib.FTextBtn>
            </div>
          )}

          <div style={{ height: 100, flexShrink: 0 }} />
        </div>
      </FLeftSiderLayout>

      <FModal
        title={null}
        footer={null}
        open={$deleteNodeModalOpen}
        width={600}
        centered={true}
        onCancel={() => {
          set$deleteNodeModalOpen(false);
          set$deleteNodeName('');
        }}
      >
        <div
          style={{
            width: 600,
            height: 380,
            backgroundColor: 'white',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <div style={{ height: 30 }} />
          <FComponentsLib.FTitleText
            type={'popup'}
            text={FI18n.i18nNext.t('nodemgnt_nodesetting_deletenode_title')}
          />
          <div style={{ height: 70 }} />
          <FComponentsLib.FTipText
            type={'second'}
            text={FI18n.i18nNext.t('nodemgnt_nodesetting_deletenode_msg', {
              NodeTitle: nodeManagerPage.setting_nodeTitle,
              NodeID: nodeManagerPage.setting_nodeName,
            })}
          />
          <div style={{ height: 20 }} />
          {/*删除节点{NodeTitle}(节点标识：{NodeID})将会删除当前节点上所有展品和授权记录*/}
          <FComponentsLib.FContentText
            type={'additional2'}
            style={{ color: '#666' }}
            text={FI18n.i18nNext.t('nodemgnt_nodesetting_deletenode_msg2')}
          />
          <div style={{ height: 20 }} />
          {/* <FSingleLineInput */}
          <FInput_PinyinSafeTextCounter
            style={{ width: 460 }}
            lengthLimit={-1}
            value={$deleteNodeName}
            placeholder={FI18n.i18nNext.t('nodemgnt_nodesetting_deletenode_label', {
              NodeID: nodeManagerPage.setting_nodeName,
            })}
            onChangeValue={(value) => {
              // console.log('*********************');
              set$deleteNodeName(value);
            }}
          />
          <div style={{ height: 40 }} />
          <div style={{ display: 'flex', gap: 30 }}>
            <FComponentsLib.FTextBtn
              type={'default'}
              onClick={() => {
                set$deleteNodeModalOpen(false);
                set$deleteNodeName('');
              }}
            >
              {FI18n.i18nNext.t('btn_cancel')}
            </FComponentsLib.FTextBtn>
            <FComponentsLib.FRectBtn
              disabled={$deleteNodeName !== nodeManagerPage.setting_nodeName}
              type={'danger1'}
              onClick={async () => {
                const { ret, errCode, msg, data } = await FServiceAPI.Node.deleteNode({
                  nodeId: nodeManagerPage.nodeId,
                });
                if (ret !== 0 || errCode !== 0) {
                  return fMessage(msg, 'error');
                }

                if (!data) {
                  return fMessage('节点删除失败', 'error');
                }
                await fMessage(
                  FI18n.i18nNext.t('nodemgnt_nodesetting_deletenode_msg_done', {
                    NodeTitle: nodeManagerPage.setting_nodeTitle,
                    NodeID: nodeManagerPage.setting_nodeName,
                  }),
                  'success',
                );
                // console.log(data);
                await dispatch<FetchNodesAction>({
                  type: 'nodes/fetchNodes',
                });
                history.replace(FUtil.LinkTo.dashboard());
                // set$deleteNodeModalOpen(false);
              }}
            >
              {FI18n.i18nNext.t('nodemgnt_nodesetting_deletenode_btn')}
            </FComponentsLib.FRectBtn>
          </div>
          <div style={{ height: 30 }} />
        </div>
      </FModal>
    </>
  );
}

export default connect(({ nodeManagerPage }: ConnectState) => ({
  nodeManagerPage,
}))(Setting);
